import React, { useState, useCallback } from 'react';
import { Clickable } from '@moda/om';
import { ModalOverlay } from '../Modal';
import { SizeGuide, SizeGuideProps } from './SizeGuide';
import './SizeGuideLink.scss';

export const SizeGuideLink: React.FC<SizeGuideProps> = ({ category, sizeEquivalents }) => {
  const [showGuide, setShowGuide] = useState(false);

  const handleClose = useCallback(() => setShowGuide(false), []);

  return (
    <>
      <Clickable className="SizeGuideLink" onClick={() => setShowGuide(true)}>
        Size Guide
      </Clickable>

      <ModalOverlay data-testid="size-guide-modal" onClose={handleClose} show={showGuide}>
        <SizeGuide category={category} onClose={handleClose} sizeEquivalents={sizeEquivalents} />
      </ModalOverlay>
    </>
  );
};
